export default {
    init() {
        // jQuery(window).load(this.loadMap);
    },

    finalize() {
        jQuery(window).load(this.loadMap);
    },

    loadMap() {
        let map = new window.google.maps.Map(document.getElementById('sites-map'), {
            center: {lat: 0, lng: 0},
            zoom: 5,
        });

        // Create bounds
        var bounds = new window.google.maps.LatLngBounds();

        // Info Windows
        var infoWindows = [];

        // Image
        // const image = window.sitesMapItem.icon_url;

        for (let i = 0; i < window.sitesMapItem.items.length; i++) {
            // Create Marker
            let item = window.sitesMapItem.items[i];
            let marker = new window.google.maps.Marker({
                position: {lat: parseFloat(item.latitude), lng: parseFloat(item.longitude)},
                icon: window.mapIconUrl,
                map: map,
            });

            var itemTitle = item.link_url ? '<a href="' + item.link_url + '">' + item.title + '</a>' : item.title;

            const contentString =
            '<div class="map-info-window">' +
            '<a class="map-info-window__image-wrapper" href="' + item.link_url + '">' +
            '<img class="map-info-window__image" src="' + item.image_url + '"/>' +
            '</a>' +
            '<h5 class="map-info-window__title">' +
            itemTitle +
            '</h5>' +
            '</div>';

            infoWindows.push(new window.google.maps.InfoWindow({
                content: contentString,
            }));

            // Bounds extend
            bounds.extend(marker.position);

            // Click to open
            window.google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infoWindows[i].open(map, marker);
                }
            })(marker, i));
        }

        // Apply bounds to map
        map.fitBounds(bounds);

    },
};
